import { makeQueryOptions } from '@mint-lib/api-zod-support/react-query';

import { defaultApi } from '@mint-sdk/api-core';

import { BudgetingStructuresListSchema } from '../shared/schemas/budgetingStructures.js';

export const budgetingStructuresList = defaultApi.declareEndpoint({
  url: 'planning-service/media-plans/$mediaPlanId/budgeting-structures/' as const,
  method: 'GET',
  responseSchema: BudgetingStructuresListSchema,
});

export const getBudgetingStructuresListQueryOptions = makeQueryOptions(
  budgetingStructuresList,
  {
    processResponse(data) {
      return data;
    },
  },
);
